import { SurveyQuestion } from './types';

/**
 * Birthday Party Booking — public request form.
 * Slug: 'birthday-party-booking'
 *
 * The backend will extract respondent_name from q_name and
 * respondent_email from q_email automatically.
 */
export const birthdayPartyBookingQuestions: SurveyQuestion[] = [

  // ── 1. Parent / Guardian contact ────────────────────────────────────────────
  {
    id: 'q_name',
    type: 'text',
    label: 'Your Name (Parent / Guardian)',
    required: true,
    placeholder: 'Full name',
  },
  {
    id: 'q_email',
    type: 'email',
    label: 'Email Address',
    required: true,
    placeholder: 'your@email.com',
  },
  {
    id: 'q_phone',
    type: 'text',
    label: 'Phone Number',
    required: true,
    placeholder: 'e.g. 250-555-1234',
  },
  {
    id: 'q_contact_pref',
    type: 'radio',
    label: 'Preferred Contact Method',
    required: false,
    options: [
      { value: 'Email',   label: 'Email' },
      { value: 'Text',    label: 'Text / SMS' },
      { value: 'Either',  label: 'Either is fine' },
    ],
  },

  // ── 2. Birthday child ────────────────────────────────────────────────────────
  {
    id: 'q_child_name',
    type: 'text',
    label: "Birthday Child's First Name",
    required: true,
    placeholder: 'e.g. Alex',
  },
  {
    id: 'q_child_age',
    type: 'radio',
    label: "Child's Age on the Day of the Party",
    required: true,
    options: [
      { value: '6',  label: '6 years old' },
      { value: '7',  label: '7 years old' },
      { value: '8',  label: '8 years old' },
      { value: '9',  label: '9 years old' },
      { value: '10', label: '10 years old' },
      { value: '11', label: '11 years old' },
      { value: '12', label: '12 years old' },
    ],
  },

  // ── 3. Party date & time ─────────────────────────────────────────────────────
  {
    id: 'q_party_date',
    type: 'text',
    label: 'Preferred Party Date',
    required: true,
    placeholder: 'e.g. April 19, 2026 (Saturday)',
  },
  {
    id: 'q_party_time',
    type: 'radio',
    label: 'Preferred Start Time',
    required: true,
    options: [
      { value: '10:00 AM – 12:00 PM', label: '10:00 AM – 12:00 PM' },
      { value: '12:00 PM – 2:00 PM',  label: '12:00 PM – 2:00 PM' },
      { value: '2:00 PM – 4:00 PM',   label: '2:00 PM – 4:00 PM' },
      { value: '4:00 PM – 6:00 PM',   label: '4:00 PM – 6:00 PM' },
    ],
  },
  {
    id: 'q_alt_date',
    type: 'text',
    label: 'Alternate Date (in case your first choice is unavailable)',
    required: false,
    placeholder: 'e.g. April 26, 2026',
  },

  // ── 4. Group size ────────────────────────────────────────────────────────────
  {
    id: 'q_num_kids',
    type: 'radio',
    label: 'Approximate Number of Children Attending (ages 6–12, maximum 12)',
    required: true,
    options: [
      { value: '1–3',   label: '1 – 3 children' },
      { value: '4–6',   label: '4 – 6 children' },
      { value: '7–9',   label: '7 – 9 children' },
      { value: '10–12', label: '10 – 12 children' },
    ],
  },

  // ── 5. LEGO theme ────────────────────────────────────────────────────────────
  {
    id: 'q_theme',
    type: 'radio',
    label: 'Choose Your LEGO Robotics Theme',
    required: true,
    options: [
      {
        value: 'Robot Battle Bots',
        label: '🤖 Robot Battle Bots — Build and program battle-ready robots that compete in friendly battles',
      },
      {
        value: 'Robot Race Cars',
        label: '🏎️ Robot Race Cars — Design robot cars and race them against each other ⭐ Most Popular',
      },
      {
        value: 'Build a Dancing Robot',
        label: '💃 Build a Dancing Robot — Create robots with moving parts that perform dance routines',
      },
    ],
  },

  // ── 6. Additional info ───────────────────────────────────────────────────────
  {
    id: 'q_special_requests',
    type: 'textarea',
    label: 'Special Requests or Notes (optional)',
    required: false,
    placeholder: 'Allergies, accessibility needs, decoration ideas, questions, or anything else helpful for us to know…',
  },
  {
    id: 'q_heard_from',
    type: 'radio',
    label: 'How did you hear about us? (optional)',
    required: false,
    options: [
      { value: 'Google Search',      label: 'Google Search' },
      { value: 'Social Media',       label: 'Social Media' },
      { value: 'Word of Mouth',      label: 'Word of Mouth / Friend' },
      { value: 'OARA Website',       label: 'OARA Website' },
      { value: 'Email / Newsletter', label: 'Email / Newsletter' },
      { value: 'Other',              label: 'Other' },
    ],
  },

  // ── 7. Cancellation policy acknowledgement ───────────────────────────────────
  {
    id: 'q_agree_cancellation',
    type: 'radio',
    label: 'Cancellation Policy: 10 days notice is required for a full refund. Cancellations within 10 days receive a 50% refund unless otherwise approved by management. Do you agree to this policy?',
    required: true,
    options: [
      { value: 'yes', label: 'Yes — I understand and agree to the cancellation policy' },
      { value: 'no',  label: 'No — I need more information before agreeing' },
    ],
  },

];
